<template>
  <div class="gkui-message-content-wrap">
    <div :class="['gkui-message-content', typeCls]">
      <span class="gkui-message-prefix" v-html="prefix" v-if="prefix"></span>
      <Loading class="gkui-message-loading-prefix" :color="loadingColor" :size="loadingSize" v-if="type === 'loading'"/>
      <span class="gkui-message-text">{{message}}</span>
      <span v-if="closable" class="gkui-message-close" @click="close">
        <i :class="{'defaultClose': !customClose}" v-html="customCloseBtn"></i>
      </span>
    </div>
  </div>
</template>
<script>
import VueTypes from 'vue-types'
import Loading from '../loading'

import messageController from './MessageController'

/**
 * Message 消息提示
 * @module components/Message
 * @author 赵卓
 * @example
 * this.$Message.info({
 *    message: '提示消息'
 * })
 */
export default {
  name: 'gku-message',
  components: {
    Loading
  },
  /**
   * 外部 props 属性
   * @property {String} [type=info]       类型 [info, success, warning, error, loading]
   * @property {String} name              唯一标识，不传会 使用默认生成的 guid 单个销毁时用到的 id
   * @property {String} message           提示消息
   * @property {Number} [duration=1.5]    停留时间，默认 1.5s； 传入 0 不会自动消失。需要手动调用关闭方法
   * @property {Function} onClose         关闭按钮的回调函数
   * @property {Boolean} [closable=false] 是否显示关闭按钮
   * @property {String} prefix            消息提示前缀 可传入 DOM 样子的字符串，组件中用  v-html 渲染
   * @property {String} customClose       自定义关闭按钮 可传入 DOM 样子的字符串，组件中用  v-html 渲染
   * @property {String} [loadingColor=blue] loading 组件的颜色 默认 blue 需要写custom.loading.scss 覆盖颜色样式。参考Loading组件demo
   * @property {String} [loadingSize=14px]  loading 组件的大小
   * @property {String} [transitionName=fade-up] 动画，可自定义动画传入
   */
  props: {
    type: VueTypes.string.def('info'),
    name: VueTypes.string,
    message: VueTypes.string,
    duration: VueTypes.number.def(1.5),
    onClose: VueTypes.func,
    closable: VueTypes.bool.def(false),
    prefix: VueTypes.string,
    customClose: VueTypes.string,
    loadingColor: VueTypes.string.def('blue'),
    loadingSize: VueTypes.string.def('14px'),
    transitionName: VueTypes.string.def('fade-up')
  },
  data () {
    return {
      timer: null
    }
  },
  computed: {
    customCloseBtn () {
      return this.customClose || ''
    },
    typeCls () {
      return messageController.getType(this.type) || ''
    }
  },
  mounted () {
    this.startTimer()
  },
  methods: {
    startTimer () {
      if (this.duration > 0) {
        this.timer = setTimeout(() => {
          this.close()
        }, this.duration * 1000)
      }
    },
    clearTimer () {
      clearTimeout(this.timer)
    },
    close () {
      this.$emit('close', this.name)
      this.onClose()
    }
  }
}
</script>

